import { resetGuestHome, type NavigationHandle } from '../navigation/navigationService';
import { clearSessionFromStorage } from './authSessionApi';
import { getAuthStore } from './store';

/** Safe exit from blocking OTP — clears partial session and returns to guest welcome. */
export async function abortUnverifiedAuthSession(navigation: NavigationHandle): Promise<void> {
  getAuthStore().clearUser();
  await clearSessionFromStorage();
  resetGuestHome(navigation);
}
